import { BookOpen, Heart, Home, MessageSquare, PlusSquare, Search } from "react-feather";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Nav from "../../global-components/src/components/navbar-mobile/navbar-mobile";
import { BanknoteArrowUpIcon, BookCheck, CirclePlus, LayoutDashboard, NotebookPen, Share2 } from "lucide-react";
import { useAuth } from "../../global-components/src";
import { NavbarPCDropdown } from "../../global-components/src/components/navbar-pc/navbar-pc-dropdown";
import { NavbarPCDropdownItem } from "../../global-components/src/components/navbar-pc/navbar-pc-dropdown-item";

type Position = 'absolute' | 'relative' | 'fixed' | 'sticky' | 'static';
interface NavbarMobileProps {
    position?: Position
} 

const NavbarMobile: React.FC<NavbarMobileProps> = ({ position }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const path = location.pathname;
    const { isAuthenticated } = useAuth(); 
    
    return (
        <div style={{display: (path == "/" || path == "/cadastro" || path == "/login") && !isAuthenticated ? "none" : "block"}}>
           <Nav linkProfile="/conta">
                {isAuthenticated ? (
                    <>
                        {/* {{-- HOME --}} */}
                        <span className={`nav-link ${path == "/" ? 'active' : ''}`}>
                            <Link aria-label="abrir menu" className="nav-link" to="/">
                                <Home className={`icon-menu-dark ${path == "/" ? 'active' : ''}`} data-feather="home" />
                            </Link>
                        </span>

                        {/* {{-- CRIAR POST --}} */}
                        <span className={`nav-link ${path == "/livros/criar" ? 'active' : ''}`}>
                            <Link aria-label="abrir menu" className="nav-link" to="/livros/criar">
                                <PlusSquare className="icon-menu-dark" data-feather="plus-square" />
                            </Link>
                        </span>
                        
                        {/* {{-- HOME --}} */}
                        <span className={`nav-link ${path == "/compartilhar" ? 'active' : ''}`}>
                            <Link aria-label="abrir menu" className="nav-link" to="/compartilhar">
                                <Share2 className={`icon-menu-dark ${path == "/compartilhar" ? 'active' : ''}`} data-feather="home" />
                            </Link>
                        </span>
                    </>
                ) : null}
           </Nav>
        </div>
    )
}

export default NavbarMobile;